import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { IconPopoverModule } from "@motorcitysystems/core";
import { NgMcsCommonUIModule } from "ng-mcs-common-ui";

import { AppIconsModule } from "../../app-icons.module";
import { HeaderComponent } from "./components/header/header.component";
import { LogoUploaderComponent } from "./components/logo-uploader/logo-uploader.component";
import { TabConfigComponent } from "./components/tab-config/tab-config.component";

@NgModule({
  declarations: [HeaderComponent, LogoUploaderComponent, TabConfigComponent],
  imports: [
    AppIconsModule,
    CommonModule,
    IconPopoverModule,
    NgbModule,
    NgMcsCommonUIModule,
    ReactiveFormsModule,
    RouterModule.forChild([]),
  ],
  exports: [HeaderComponent, LogoUploaderComponent, TabConfigComponent],
})
export class SharedModule {}
